export const color = {
    bg: "#04010e",
    fg: "white",
    hv:"#4f45e31d"
} 